export function initCounter() {
  // Get all <strong> elements
  var strongElements = document.querySelectorAll('.image-counter__content p strong');
  
  // Iterate over each <strong> element
  strongElements.forEach(function(element) {
    // Add a data-attribute dynamically
    element.setAttribute('data-attribute-counter', element.innerHTML);

    // Retrieve the data-attribute value
    var dataAttributeValue = parseInt(element.getAttribute('data-attribute-counter'));
    var countDuration = 3000; // Modify this value as desired

    // Create an intersection observer
    var observer = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {

          // Start counting from 0 to the data-attribute value
          var count = 0;
          var increment = Math.ceil(dataAttributeValue / (countDuration / 100));
          var interval = setInterval(function() {
            // Update the element's text content with the current count
            element.textContent = count;

            if (count >= dataAttributeValue) {
              // Stop counting when the count reaches the data-attribute value
              element.textContent = dataAttributeValue;
              clearInterval(interval);
            } else {
              count += increment;
            }
          }, 100);

          // Stop observing the element after starting the count
          observer.unobserve(entry.target);
        }
      });
    });

    // Observe the <strong> element
    observer.observe(element);
  });
}







